import apiClient from './client';

export const ActivityFrequencyAxiosInstance = apiClient;